var render = function render(){
  var _vm$selectedData, _vm$selectedData2, _vm$selectedData3, _vm$selectedData4, _vm$selectedData5, _vm$selectedData6, _vm$selectedData6$att, _vm$selectedData7, _vm$selectedData$note, _vm$selectedData8, _vm$selectedData9, _vm$selectedData10, _vm$selectedData11, _vm$selectedData11$jo, _vm$selectedData12, _vm$selectedData12$jo, _vm$selectedData13, _vm$selectedData13$jo, _vm$selectedData13$jo2, _vm$selectedData14, _vm$selectedData14$jo, _vm$selectedData14$jo2, _vm$selectedData15, _vm$selectedData15$jo, _vm$selectedData15$jo2, _vm$selectedData16, _vm$selectedData16$jo, _vm$selectedData17, _vm$selectedData18, _vm$selectedData18$jo, _vm$selectedData19, _vm$selectedData19$jo, _vm$selectedData20, _vm$selectedData21, _vm$selectedData$powe, _vm$selectedData22, _vm$selectedData23, _vm$selectedData24, _vm$selectedData25, _vm$selectedData26, _vm$selectedData26$jo, _vm$selectedData27, _vm$selectedData27$lo, _vm$selectedData28, _vm$selectedData28$lo;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "card p-3"
  }, [_c('CustomNav', {
    staticClass: "mb-3",
    attrs: {
      "items": _vm.rightTabs
    },
    on: {
      "item-click": function itemClick(tab) {
        return _vm.activeTabRight = tab;
      }
    }
  }), _vm.activeTabRight == 1 ? [_c('PmsFleetDetailHeader', {
    attrs: {
      "selectedData": _vm.selectedData
    }
  }), _c('table', {
    staticClass: "table table-striped mb-0"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v("Last Maintenance Date")]), _c('td', {
    staticClass: "font-semibold text-black"
  }, [_vm._v(" " + _vm._s(_vm.formatDate((_vm$selectedData = _vm.selectedData) === null || _vm$selectedData === void 0 ? void 0 : _vm$selectedData.last_maintenance_date)) + " ")])]), _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v("Due")]), _c('td', {
    staticClass: "font-semibold text-black"
  }, [_vm.selectedData.triggers == 'CALENDAR' ? [_vm._v(" " + _vm._s(_vm.formatDate(_vm.selectedData.possible_maintenance_date)) + " ")] : [_vm._v(" " + _vm._s(_vm.formatNumber(_vm.selectedData.possible_maintenance_hours) || '0') + " Hours ")]], 2)]), _c('tr', [_c('td', {
    staticClass: "text-muted",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("Maintenance Date")]), _c('td', {
    staticClass: "font-semibold text-black"
  }, [_vm._v(" " + _vm._s(_vm.formatDate((_vm$selectedData2 = _vm.selectedData) === null || _vm$selectedData2 === void 0 ? void 0 : _vm$selectedData2.maintenance_date)) + " ")])]), ((_vm$selectedData3 = _vm.selectedData) === null || _vm$selectedData3 === void 0 ? void 0 : _vm$selectedData3.triggers) == 'COUNTER' ? _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v("Maintenance Hours")]), _c('td', {
    staticClass: "font-semibold text-black"
  }, [_vm._v(" " + _vm._s(_vm.formatNumber((_vm$selectedData4 = _vm.selectedData) === null || _vm$selectedData4 === void 0 ? void 0 : _vm$selectedData4.last_maintenance_hours)) + " Hours ")])]) : _vm._e(), _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v("Cost")]), _c('td', {
    staticClass: "font-semibold text-black"
  }, [_vm._v(" " + _vm._s(_vm.formatCurrency((_vm$selectedData5 = _vm.selectedData) === null || _vm$selectedData5 === void 0 ? void 0 : _vm$selectedData5.cost)) + " ")])]), _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v("Attachment")]), _c('td', [(_vm$selectedData6 = _vm.selectedData) !== null && _vm$selectedData6 !== void 0 && (_vm$selectedData6$att = _vm$selectedData6.attachments) !== null && _vm$selectedData6$att !== void 0 && _vm$selectedData6$att.length ? _vm._l((_vm$selectedData7 = _vm.selectedData) === null || _vm$selectedData7 === void 0 ? void 0 : _vm$selectedData7.attachments, function (file, idx) {
    return _c('b-badge', {
      key: "att-".concat(idx),
      staticClass: "mr-2 cursor-pointer",
      attrs: {
        "variant": "warning",
        "pill": ""
      },
      on: {
        "click": function click($event) {
          return _vm.onPreview(file === null || file === void 0 ? void 0 : file.fileurl);
        }
      }
    }, [_vm._v(" " + _vm._s(file.filename) + " "), _c('i', {
      staticClass: "fa fa-download ml-2",
      staticStyle: {
        "font-size": "12px"
      }
    })]);
  }) : [_vm._v("-")]], 2)]), _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v("Notes")]), _c('td', {
    staticClass: "font-semibold text-black"
  }, [_vm._v(" " + _vm._s((_vm$selectedData$note = (_vm$selectedData8 = _vm.selectedData) === null || _vm$selectedData8 === void 0 ? void 0 : _vm$selectedData8.notes) !== null && _vm$selectedData$note !== void 0 ? _vm$selectedData$note : '-') + " ")])]), _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v("Status")]), _c('td', [_c('span', {
    staticClass: "badge",
    class: _vm.getStatusBadgeClass((_vm$selectedData9 = _vm.selectedData) === null || _vm$selectedData9 === void 0 ? void 0 : _vm$selectedData9.status)
  }, [_vm._v(" " + _vm._s((_vm$selectedData10 = _vm.selectedData) === null || _vm$selectedData10 === void 0 ? void 0 : _vm$selectedData10.status) + " ")])])])])]), _vm._m(0), _c('table', {
    staticClass: "table table-striped mb-0"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "text-muted",
    staticStyle: {
      "width": "30%"
    }
  }, [_vm._v("Job Code")]), _c('td', {
    staticClass: "font-semibold text-black"
  }, [_vm._v(" " + _vm._s((_vm$selectedData11 = _vm.selectedData) === null || _vm$selectedData11 === void 0 ? void 0 : (_vm$selectedData11$jo = _vm$selectedData11.job_library) === null || _vm$selectedData11$jo === void 0 ? void 0 : _vm$selectedData11$jo.code) + " ")])]), _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v("Job Name")]), _c('td', {
    staticClass: "font-semibold text-black"
  }, [_vm._v(" " + _vm._s((_vm$selectedData12 = _vm.selectedData) === null || _vm$selectedData12 === void 0 ? void 0 : (_vm$selectedData12$jo = _vm$selectedData12.job_library) === null || _vm$selectedData12$jo === void 0 ? void 0 : _vm$selectedData12$jo.name) + " ")])]), _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v("Equipment Category")]), _c('td', {
    staticClass: "font-semibold text-black text-uppercase"
  }, [_vm._v(" " + _vm._s((_vm$selectedData13 = _vm.selectedData) === null || _vm$selectedData13 === void 0 ? void 0 : (_vm$selectedData13$jo = _vm$selectedData13.job_library) === null || _vm$selectedData13$jo === void 0 ? void 0 : (_vm$selectedData13$jo2 = _vm$selectedData13$jo.maintenance_component) === null || _vm$selectedData13$jo2 === void 0 ? void 0 : _vm$selectedData13$jo2.component_name) + " ")])]), _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v("Equipment")]), _c('td', {
    staticClass: "font-semibold text-black"
  }, [_vm._v(" " + _vm._s((_vm$selectedData14 = _vm.selectedData) === null || _vm$selectedData14 === void 0 ? void 0 : (_vm$selectedData14$jo = _vm$selectedData14.job_library) === null || _vm$selectedData14$jo === void 0 ? void 0 : (_vm$selectedData14$jo2 = _vm$selectedData14$jo.maintenance_master) === null || _vm$selectedData14$jo2 === void 0 ? void 0 : _vm$selectedData14$jo2.equipment_name) + " ")])]), _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v("Job Type")]), _c('td', {
    staticClass: "font-semibold text-black"
  }, [_vm._v(" " + _vm._s((_vm$selectedData15 = _vm.selectedData) === null || _vm$selectedData15 === void 0 ? void 0 : (_vm$selectedData15$jo = _vm$selectedData15.job_library) === null || _vm$selectedData15$jo === void 0 ? void 0 : (_vm$selectedData15$jo2 = _vm$selectedData15$jo.maintenance_job_type) === null || _vm$selectedData15$jo2 === void 0 ? void 0 : _vm$selectedData15$jo2.job_type_index) + " ")])]), _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v("Method")]), _c('td', {
    staticClass: "font-semibold text-black"
  }, [_vm._v(" " + _vm._s((_vm$selectedData16 = _vm.selectedData) === null || _vm$selectedData16 === void 0 ? void 0 : (_vm$selectedData16$jo = _vm$selectedData16.job_library) === null || _vm$selectedData16$jo === void 0 ? void 0 : _vm$selectedData16$jo.method) + " ")])]), _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v("Interval")]), _c('td', {
    staticClass: "font-semibold text-black"
  }, [((_vm$selectedData17 = _vm.selectedData) === null || _vm$selectedData17 === void 0 ? void 0 : _vm$selectedData17.triggers) == 'CALENDAR' ? [_vm._v(" " + _vm._s((_vm$selectedData18 = _vm.selectedData) === null || _vm$selectedData18 === void 0 ? void 0 : (_vm$selectedData18$jo = _vm$selectedData18.job_library) === null || _vm$selectedData18$jo === void 0 ? void 0 : _vm$selectedData18$jo.calendar_interval) + " " + _vm._s((_vm$selectedData19 = _vm.selectedData) === null || _vm$selectedData19 === void 0 ? void 0 : (_vm$selectedData19$jo = _vm$selectedData19.job_library) === null || _vm$selectedData19$jo === void 0 ? void 0 : _vm$selectedData19$jo.calendar_type) + " ")] : [_vm._v(" " + _vm._s(_vm.formatNumber((_vm$selectedData20 = _vm.selectedData) === null || _vm$selectedData20 === void 0 ? void 0 : _vm$selectedData20.trigger_interval)) + " Hours ")]], 2)]), ((_vm$selectedData21 = _vm.selectedData) === null || _vm$selectedData21 === void 0 ? void 0 : _vm$selectedData21.triggers) == 'COUNTER' ? _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v("Engine Position")]), _c('td', {
    staticClass: "font-semibold text-black"
  }, [[_vm._v(" " + _vm._s((_vm$selectedData$powe = (_vm$selectedData22 = _vm.selectedData) === null || _vm$selectedData22 === void 0 ? void 0 : _vm$selectedData22.power_type_name) !== null && _vm$selectedData$powe !== void 0 ? _vm$selectedData$powe : '-') + " ")]], 2)]) : _vm._e(), ((_vm$selectedData23 = _vm.selectedData) === null || _vm$selectedData23 === void 0 ? void 0 : _vm$selectedData23.triggers) == 'COUNTER' ? _c('tr', [_c('td', {
    staticClass: "text-muted"
  }, [_vm._v("Engine Brand")]), _c('td', {
    staticClass: "font-semibold text-black"
  }, [_vm._v(" " + _vm._s((_vm$selectedData24 = _vm.selectedData) === null || _vm$selectedData24 === void 0 ? void 0 : _vm$selectedData24.power_series_name) + " - " + _vm._s((_vm$selectedData25 = _vm.selectedData) === null || _vm$selectedData25 === void 0 ? void 0 : _vm$selectedData25.power_series_model) + " ")])]) : _vm._e(), _c('tr', [_c('td', {
    staticClass: "text-muted align-top"
  }, [_vm._v("Job Description")]), _c('td', {
    staticClass: "font-semibold text-black job-description",
    domProps: {
      "innerHTML": _vm._s(((_vm$selectedData26 = _vm.selectedData) === null || _vm$selectedData26 === void 0 ? void 0 : (_vm$selectedData26$jo = _vm$selectedData26.job_library) === null || _vm$selectedData26$jo === void 0 ? void 0 : _vm$selectedData26$jo.job_description) || '-')
    }
  })])])]), _c('TablePostponed', {
    attrs: {
      "selectedData": _vm.selectedData
    }
  })] : _vm.activeTabRight == 2 ? [_c('MaintenanceCommentFormNew', {
    attrs: {
      "isPreview": "",
      "selectedData": _vm.selectedData
    }
  })] : [(_vm$selectedData27 = _vm.selectedData) !== null && _vm$selectedData27 !== void 0 && (_vm$selectedData27$lo = _vm$selectedData27.logs) !== null && _vm$selectedData27$lo !== void 0 && _vm$selectedData27$lo.length ? [_c('MaintenanceLogs', {
    attrs: {
      "logs": (_vm$selectedData28 = _vm.selectedData) === null || _vm$selectedData28 === void 0 ? void 0 : (_vm$selectedData28$lo = _vm$selectedData28.logs) === null || _vm$selectedData28$lo === void 0 ? void 0 : _vm$selectedData28$lo.map(function (log) {
        return {
          name: log.created_by,
          date: log.created_date,
          description: "Changed Status to ".concat(log.status)
        };
      })
    }
  })] : _vm._e()]], 2);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('h4', {
    staticClass: "text-primary my-3"
  }, [_c('strong', [_vm._v("Job Library Info")])]);

}]

export { render, staticRenderFns }